export enum Period {
  ThisMonth = 'this_month',
  ThisQuarter = 'this_quarter',
  ThisYear = 'this_year',
  All = '',
}
